import { memo } from "react";

import getLockerProviderData from "@components/Lockers/_lib/getLockerProviderData";

const LockerMapMarker = memo(({ marker }) => {
  const { name, color } = getLockerProviderData(marker);
  return (
    <div
      style={{
        backgroundColor: color,
        position: "relative",
      }}
      className="text-white text-[12px] font-medium px-[6px] py-[4px] rounded"
    >
      {name}

      {/* Inline styles, not a style tag: every marker renders its own node, so a shared
          selector would let the last one in the document recolor every other arrow */}
      <div
        style={{
          position: "absolute",
          bottom: "-6px",
          left: "50%",
          transform: "translateX(-50%)",
          width: 0,
          height: 0,
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: `6px solid ${color}`,
        }}
      />
    </div>
  );
});

LockerMapMarker.displayName = "LockerMapMarker";

export default LockerMapMarker;
